// Bitwise action flags. Stored as an int in BC_Identity's RolePermission.Actions column so the
// frontend and backend can speak the same number — keep these powers of two and never reuse a
// retired bit, since old role rows may still hold it.
export enum PermissionAction {
  None    = 0,
  View    = 1 << 0,
  Create  = 1 << 1,
  Edit    = 1 << 2,
  Delete  = 1 << 3,
  Approve = 1 << 4,
  Void    = 1 << 5,
  Export  = 1 << 6,
}

export type PermissionActionMask = number;

export const ALL_ACTIONS: readonly PermissionAction[] = [
  PermissionAction.View,
  PermissionAction.Create,
  PermissionAction.Edit,
  PermissionAction.Delete,
  PermissionAction.Approve,
  PermissionAction.Void,
  PermissionAction.Export,
];

export const PermissionActionLabel: Record<PermissionAction, string> = {
  [PermissionAction.None]:    '—',
  [PermissionAction.View]:    'View',
  [PermissionAction.Create]:  'Create',
  [PermissionAction.Edit]:    'Edit',
  [PermissionAction.Delete]:  'Delete',
  [PermissionAction.Approve]: 'Approve',
  [PermissionAction.Void]:    'Void',
  [PermissionAction.Export]:  'Export',
};

export function hasAction(mask: PermissionActionMask, action: PermissionAction): boolean {
  return (mask & action) === action;
}

export function listActions(mask: PermissionActionMask): PermissionAction[] {
  return ALL_ACTIONS.filter(a => hasAction(mask, a));
}

export function combine(...actions: PermissionAction[]): PermissionActionMask {
  return actions.reduce((acc, a) => acc | a, PermissionAction.None);
}
